import {createAction} from 'redux-actions';

// unique key namespace used by combineReducers.
// By convention it will match the directory structure to
// make it easy to locate the src.
// Also action types will prefix with the capitalized version
export const key = 'autoLogout';

// action creators
export const timerStart = createAction(`${key}/TIMER_START`);
export const timerCancel = createAction(`${key}/TIMER_CANCEL`);
export const timerReset = createAction(`${key}/TIMER_RESET`);
export const timerEnd = createAction(`${key}/TIMER_END`);
export const timerDecrement = createAction(`${key}/TIMER_DECREMENT`);
export const timerRefreshRequest = createAction(`${key}/TIMER_REFRESH_REQUEST`);
export const timerStartError = createAction(`${key}/TIMER_START_ERROR`,
  (err) => ({
    err,
    error: true
  })
);

export default {
  timerStart,
  timerCancel,
  timerReset,
  timerEnd,
  timerDecrement,
  timerStartError,
  timerRefreshRequest
};



// WEBPACK FOOTER //
// ./src/util/redux/autoLogout/actions.js